<!-- eslint-disable -->
<template lang="pug">
    .settings(v-if='settings')
        template(v-if="parametersFrom === 'homework'")
            template(v-if='settings.amountOfExamples && !settings.infinityAmountOfExamples')
                | {{ $i18n.t('trainer.trainer_gameFormSetting_numOfExamples') }}: {{ settings.amountOfExamples }}
                br
            template
                | {{ $i18n.t('trainer.trainer_gameFormSetting_category_of_words') }}: {{ $i18n.t('trainer.trainer_gameFormSetting_class_' + settings.theme) }}
                br
        slot

</template>

<script>
/*eslint-disable*/
import TrainerUtilities from '../../../utils/trainer/trainer';
import gamePreviewMixin from "../../../utils/trainer/gamePreviewMixin";

export default {
    mixins: [TrainerUtilities, gamePreviewMixin],
    props: {
        game: Object,
        parameters: Object,
        userId: Number,
        parametersFrom: {
            type: String,
            default: 'homework'
        }
    }
}
</script>
